import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { useState as p, useRef as h, useEffect as k } from "react";
import { attributes as y } from "../utils/attributes.js";
import { ButtonIcon as C } from "../ButtonIcon/ButtonIcon.js";
import { c as l } from "../../createLucideIcon-BC8wu-bu.js";
import { C as I, a as b } from "../../circle-x-CjgDu1_I.js";
import '../../assets/Toast.css';/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x = l("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M = l("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function $({
  message: e,
  time: n,
  style: m,
  variant: c,
  className: u = "",
  duration: i = 3e3
}) {
  const [a, r] = p(e), t = h(null);
  k(() => {
    t.current && clearTimeout(t.current), r(e), e && (t.current = window.setTimeout(() => r(""), i));
  }, [e, n, i]);
  const f = () => {
    t.current && clearTimeout(t.current), r("");
  }, d = {
    success: I,
    error: b,
    default: x
  }[c];
  return /* @__PURE__ */ s(
    "div",
    {
      className: `toast ${u} toast--${c}`,
      ...y({ "aria-hidden": n == 0 || a === "" }),
      style: m,
      children: [
        /* @__PURE__ */ o(d, { size: "1.25rem", className: "toast-icon" }),
        /* @__PURE__ */ s("span", { children: [
          /* @__PURE__ */ s("b", { className: "toast-title", children: [
            c,
            " ! "
          ] }),
          /* @__PURE__ */ o("span", { children: a })
        ] }),
        /* @__PURE__ */ o(
          C,
          {
            onClick: f,
            variant: "small",
            className: "toast-close",
            Icon: () => /* @__PURE__ */ o(M, { size: "1.25rem" })
          }
        )
      ]
    }
  );
}
export {
  $ as Toast
};
//# sourceMappingURL=Toast.js.map
